import { Component, Watch } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import { Task, TaskRelatedCell } from '@/modules/Task/interfaces/task'
import { taskStatusColor, taskStatus } from '@/modules/Task/helpers/task'
import { getTask, commentToTask, completeTask, deleteTask } from '../gql/task.gql'
import AppTextarea from '@/components/AppTextarea.vue'
import TaskDialog from '@/modules/Task/scripts/task-dialog'
import { mixins } from 'vue-class-component'
import TaskProps from '@/modules/Task/components/TaskProps.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'
import { Policy } from '@/modules/Policy/interfaces/policy'

@Component({
  components: {
    AppBreadcrumbs,
    TaskProps,
    AppDialog,
    AppTextarea
  }
})
export default class TaskDetail extends mixins(TaskDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: `Task`,
      to: { name: 'TaskList' }
    }
  ]
  taskId = 0

  taskInfo: Task | null = null
  activeComplete = false

  dialogShow = false
  disableConfirm = false
  activeDelete = false
  activeEdit = false

  dialogType = ''
  dialogTitle = {
    'complete': 'Complete Task',
    'delete': 'Delete Task'
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  taskStatus = taskStatus
  taskStatusColor = taskStatusColor

  commentInput = {
    content: ''
  }

  async mounted () {
    this.pageInit()
  }

  @Watch('$route.params.id')
  onRouteChanged (val: any, oldVal: any) {
    this.pageInit()
  }

  pageInit () {
    this.taskId = Number(this.$route.params.id)
    if (this.breadcrumbs.length === 1) {
      this.breadcrumbs.push({
        text: this.taskId
      })
    } else {
      this.breadcrumbs[1].text = this.taskId
    }
    this.getTaskDetail()
  }

  async getTaskDetail () {
    const { taskId } = this
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getTask,
        variables: {
          taskId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const relations: TaskRelatedCell[] = []
      if (result.data.getTask.cases) {
        this.$R.forEach((item: Case) => {
          const cell: TaskRelatedCell = {
            type: 'CASE',
            cell: {
              id: +item.id,
              name: item.inquiryName
            }
          }
          relations.push(cell)
        }, result.data.getTask.cases)
      }
      if (result.data.getTask.policies) {
        this.$R.forEach((item: Policy) => {
          const cell: TaskRelatedCell = {
            type: 'POLICY',
            cell: {
              id: +item.id,
              name: item.policyName
            }
          }
          relations.push(cell)
        }, result.data.getTask.policies)
      }
      if (result.data.getTask.accounts) {
        this.$R.forEach((item: Account) => {
          const cell: TaskRelatedCell = {
            type: 'ACCOUNT',
            cell: {
              id: +item.id,
              name: item.name
            }
          }
          relations.push(cell)
        }, result.data.getTask.accounts)
      }
      result.data.getTask.relations = relations.concat()
      this.taskInfo = result.data.getTask
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async completeTaskConfirm () {
    const { taskId } = this
    try {
      const result = await this.$apollo.mutate({
        mutation: completeTask,
        variables: {
          taskId
        }
      })
      const res = result.data.completeTask
      if (!res) {
        return
      }
      showNotification({
        msg: 'Task complete successfully',
        type: SnackType.Success
      })
      this.$router.replace({
        name: 'TaskList'
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteTaskConfirm () {
    const { taskId } = this
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteTask,
        variables: {
          taskId
        }
      })
      const res = result.data.deleteTask
      if (!res) {
        return
      }
      showNotification({
        msg: 'Task delete successfully',
        type: SnackType.Success
      })
      this.$router.replace({
        name: 'TaskList'
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newComment () {
    const { taskId, commentInput } = this
    const { content } = commentInput
    if (!content) {
      return
    }
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: commentToTask,
        variables: {
          taskId,
          content
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.commentInput = {
        content: ''
      }
      this.pageInit()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  showActionDialog (type: string) {
    this.dialogType = type
    this.dialogShow = true
  }

  hideActionDialog () {
    this.dialogShow = false
    this.dialogType = ''
  }

  dialogConfirm (type: string) {
    switch (type) {
      case 'complete':
        this.completeTaskConfirm()
        break
      case 'delete':
        this.deleteTaskConfirm()
        break
      default:
        break
    }
  }

  onSuccessHandler () {
    this.hideTaskDialog()
    this.pageInit()
  }
}
